module.exports = __webpack_public_path__ + "7b9152d2d44c4e2c8a1e93cfe1ae7491.fbx";